import {
  Layer,
  type LayerProps as MapLayerProps,
} from "react-map-gl/maplibre";
import { hexToHSL } from "../layer-utils";
import { useEffect, useState } from "react";
import { LayerProps } from "../explorer-display-layers";
import { HSLToHSLString, highlightTypeForGeo } from "./paint";
import { highlightPaintForGeo } from "./paint";
import { useTheme } from "@/components/theme-provider";

export function PrimaryHighlightLayer(props: LayerProps) {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  // `type` is resolved at runtime, so the layer-spec union can't be narrowed
  // and paint/filter have to be checked against it as a whole.
  const layerProps = {
    layout: {
      visibility: props.layerConfig.visible ? "visible" : "none",
    },
    beforeId: props.beforeId ?? "",
    id: props.id,
    type: highlightTypeForGeo(props.layer.geometry),
    source: props.source.description,
    "source-layer": props.layer.id,
    paint: highlightPaintForGeo(
      isDark ? "#EEEEEE" : "#616161",
      1,
      props.layer.geometry,
      3
    ),
    filter: props.layerConfig.primaryHighlightsFilter,
  } as MapLayerProps;

  return <Layer key={props.id} {...layerProps} />;
}
